import { Breadcrumb, BreadcrumbItem, Column, Content, Grid, Header, HeaderContainer, HeaderGlobalAction, HeaderGlobalBar, HeaderMenuButton, HeaderName, Row, SideNav, SideNavItems, SideNavMenu, SideNavMenuItem, SkipToContent } from "carbon-components-react";
import { connect } from "react-redux"
import { Link, useHistory, useLocation } from "react-router-dom"
import { Logout32 } from '@carbon/icons-react'
import Errors from "./Errors"
import SuccessNotification from "./SuccessNotification";

function UIShell({ errors, successMessage, breadcrumbs = [], children }) {

    const history = useHistory()
    let location = useLocation();

    const goTo = (breadcrumbItem) => {
        if (breadcrumbItem.link) {
            history.push(breadcrumbItem.link)
        }
    }

    const logout = () => {
        localStorage.removeItem('accessToken')

        history.push('/authentication/login')
    }

    const checkRouter = (route) => {
        const locationCheck = location.pathname.split('/')
        return locationCheck.includes(route)
    }

    return (
        <div className="container">
            <HeaderContainer render={({ isSideNavExpanded, onClickSideNavExpand }) => (
                <>
                    <Header>
                        <SkipToContent />
                        <HeaderMenuButton
                            aria-label="Open menu"
                            isCollapsible
                            onClick={onClickSideNavExpand}
                            isActive={isSideNavExpanded}
                        />
                        <HeaderName prefix="CMS">
                            Job posting
                        </HeaderName>
                        <HeaderGlobalBar>
                            <HeaderGlobalAction aria-label="Logout" onClick={logout}>
                                <Logout32 />
                            </HeaderGlobalAction>
                        </HeaderGlobalBar>
                        <SideNav expanded={isSideNavExpanded} style={{ backgroundColor: '#fff' }}>
                            <SideNavItems>
                                <SideNavMenuItem href="#" className={checkRouter("accounts") ? "active" : ""}>
                                    <Link to="/accounts">
                                        Accounts
                                    </Link>
                                </SideNavMenuItem>
                                <SideNavMenuItem href="#" className={checkRouter("projects") ? "active" : ""}>
                                    <Link to="/projects">
                                        Projects
                                    </Link>
                                </SideNavMenuItem>
                                <SideNavMenuItem href="#" className={checkRouter("jobs") ? "active" : ""}>
                                    <Link to="/jobs">
                                        Job Vacancies
                                    </Link>
                                </SideNavMenuItem>
                                <SideNavMenu title="Master Data" defaultExpanded={true}>
                                    <SideNavMenuItem
                                        className={checkRouter("categories") ? "active" : ""}
                                    >
                                        <Link to="/categories">
                                            Categories
                                        </Link>
                                    </SideNavMenuItem>
                                    <SideNavMenuItem
                                        className={checkRouter("skills") ? "active" : ""}
                                    >
                                        <Link to="/skills">
                                            Skills
                                        </Link>
                                    </SideNavMenuItem>    
                                    <SideNavMenuItem
                                        className={checkRouter("industries") ? "active" : ""}
                                    >
                                        <Link to="/industries">
                                            Industries
                                        </Link>
                                    </SideNavMenuItem>                                                           
                                    <SideNavMenuItem
                                        className={checkRouter("faqs") ? "active" : ""}
                                    >
                                        <Link to="/faqs">
                                            Faqs
                                        </Link>
                                    </SideNavMenuItem>
                                    <SideNavMenuItem
                                        className={checkRouter("policies") ? "active" : ""}
                                    >
                                        <Link to="/policies">
                                            Policies and Terms
                                        </Link>
                                    </SideNavMenuItem>
                                    {/* <SideNavMenuItem
                                        className={checkRouter("subscriptions") ? "active" : ""}
                                    >
                                        <Link to="/subscriptions">
                                            Subscriptions
                                        </Link>
                                    </SideNavMenuItem>
                                    <SideNavMenuItem>
                                        <Link to="/about-us">
                                            About Us
                                        </Link>
                                    </SideNavMenuItem> */}
                                </SideNavMenu>
                            </SideNavItems>
                        </SideNav>
                    </Header>


                </>
            )} />


            <Content className="main-content">
                <Grid className="bg-white" style={{ paddingTop: 15 }}>
                    <Row>
                        <Column>
                            <Breadcrumb style={{ marginBottom: 20 }}>
                                {breadcrumbs.map((v) => {
                                    return (
                                        <>
                                            <BreadcrumbItem >
                                                <a href="#" onClick={() => goTo(v)}>{v.name}</a>
                                            </BreadcrumbItem>
                                        </>
                                    )
                                })}
                            </Breadcrumb>
                        </Column>
                    </Row>

                    {successMessage && <SuccessNotification title={successMessage.title} subTitle={successMessage.subTitle} />}
                    {errors && <Errors errors={errors} />}
                </Grid>
                <div className="bg-white" style={{ minHeight: 700 }}>
                    {children}
                </div>
            </Content>

        </div>
    )
}

const mapStateToProps = state => {
    return {
        errors: state.uxReducer.errors,
        successMessage: state.uxReducer.successMessage
    }
}

export default connect(mapStateToProps)(UIShell)
